export { PRIVACY_POLICY_URL, TERMS_URL } from '../cpf-validation/constants'

export const DEFAULT_COURSE = 'Direito'
export const FILE_MAX_SIZE_BYTES = 10 * 1024 * 1024

export const ACCEPTED_MIME_TYPES = ['image/jpeg', 'image/png', 'application/pdf'] as const

export const ACCEPTED_FILE_INPUT = '.jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf'

export function isValidEnrollmentDocumentFile(file: File) {
  if (
    !ACCEPTED_MIME_TYPES.includes(file.type as (typeof ACCEPTED_MIME_TYPES)[number]) &&
    !file.name.match(/\.(pdf|jpe?g|png)$/i)
  ) {
    return false
  }

  return file.size <= FILE_MAX_SIZE_BYTES
}

export function clearEnrollmentDocumentFromSharedData<
  T extends { documentData?: string; documentFile?: File }
>(sharedData: T): T {
  return {
    ...sharedData,
    documentData: undefined,
    documentFile: undefined,
  }
}

export const ENROLLMENT_PERIOD_OPTIONS = Array.from({ length: 10 }, (_, index) => {
  const semester = index + 1
  return `${semester}º semestre`
})
